<div fxLayout="row">
  <div fxFlex="100">
    <div class="spend-limit" id="spendLimit">
      <div class="content">
        <div fxLayout="row wrap">
          <div fxFlex.gt-sm="55" fxFlex.lt-sm="100">
            <h1>Want to spend more than your spend limit?</h1>
            <br />
            <p>
              You can, but instead of paying 3 x equal payments, you will have
              to pay the excess with your first instalment.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
